import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';

import Carousel from '@/components/Carousel';
import EventsCardSmall from '@/components/molecules/EventsCardSmall';
import { fetchEventsData } from '@/services/contentEvents/actions';
import { orderEventsByDate } from '@/utils/dataFormatting';
import * as DateParser from '@/utils/dateParser';

import './UpcomingEvents.scss';

class UpcomingEvents extends Component {
	state = { visible: false, lazyItemRef: null };

	constructor(props) {
		super(props);
		this.fetchEventsList();
	}

	async fetchEventsList(listUrl) {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
		Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/All Events.json?v=${Math.random()}`)
			.then((response) => this.fetchEventsContent(response.data.contents))
			.then(res => { this.sortEvents(res); });
	}

	removePastEvents(events) {
		return events.filter(event => {
			let passedStartDate = false;
			let passedEndDate = false;
			for (let field of event) {
				if (field.id === 'startdate') {
					passedStartDate = DateParser.hasDatePassed(field.value);
				}
				else if (field.id === 'enddate') {
					passedEndDate = DateParser.hasDatePassed(field.value);
				}
			}

			return !passedStartDate || !passedEndDate;
		});
	}

	async getEventContent(url) {
		return Axios.get(url);
	}

	async fetchEventsContent(listData) {
		let that = this;

		let eventUrls = listData.map((item) => {
			for (let field of item.fields) {
				if (field.id === 'event') {
					return field.value;
				}
			}
		});

		let eventsContent = eventUrls.map(async (url) => {
			let contents = await this.getEventContent(url);
			return contents;
		});

		return eventsContent;
	}

	orderEventsByDate(events) {
		let eventsData = events.map(event => event.data.contents[0].fields);

		return eventsData.sort((a, b) => {
			let dateA, dateB;
			for (let i = 0; i < a.length; i++) {
				if (a[i].id === 'startdate') {
					dateA = moment(DateParser.formatDateWithSlashes(a[i].value));
					break;
				}
			}
			for (let j = 0; j < b.length; j++) {
				if (b[j].id === 'startdate') {
					dateB = moment(DateParser.formatDateWithSlashes(b[j].value));
					break;
				}
			}
			return dateA.isBefore(dateB) ? -1 : 1;
		});
	}

	sortEvents(stuff) {
		return Promise.all(stuff)
			.then((vals) => vals)
			.then((lot) => {
				let returnval = this.filterEvents(this.removePastEvents(this.orderEventsByDate(lot)));
				this.setState({ events: returnval });
			});
	}

	async
	filterEvents(currEvts) {
		if (this.props.filter) {
			let filteredEvts = [];
			console.log(currEvts);
			for (let i = 0; i < currEvts.length; i++) {
				for (let j = 0; j < currEvts[i].length; j++) {
					if (currEvts[i][j].id === 'urlslug' && currEvts[i][j].value !== this.props.filter) {
						filteredEvts.push(currEvts[i]);
						break;
					}
				}
			}

			return filteredEvts;
		}
		return currEvts;
		
	}

	lazyCallback() {
		if (!this.state.visible) {
			this.setState({ visible: true });
		}
	}

	render() {
		// if (!this.props.eventsData && !this.props.data) {
		// 	return null;
		// }

		// Use props data if it exists, otherwise use app-wide state eventsData
		// const eventsData = orderEventsByDate(this.props.data || this.props.eventsData);
		// const filteredData = eventsData.filter(this.props.filter || (() => true));

		if (!this.state.events || !this.state.events.length) { return null; }

		let eventsData = this.state.events;

		return (
			<nav
				className="UpcomingEvents"
				ref={el => {
					if (!this.state.lazyItemRef && el) {
						this.setState({ lazyItemRef: el });
					}
				}}
				style={this.state.visible ? { opacity: 1 } : { opacity: 0 }}
			>
				<div className="UpcomingEvents__upcoming-content">
					<h2 className="UpcomingEvents__title">
						{eventsData.optional_title || 'Events'}
					</h2>
					<Carousel
						className="UpcomingEvents__carousel"
						settings={{ lazyload: false, responsive: { 768: { items: 4 } } }}
						slidesToShow={4}
					>
						{eventsData
							.map((event, index) => (<EventsCardSmall
								className="UpcomingEvents__card"
								key={`events-page-card_${index}`}
								bgColor="transparent"
								event={event}
								routeProps={this.props.routeProps}
								lazyCallback={() => this.lazyCallback()}
							                        />))}
					</Carousel>
				</div>
			</nav>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	eventsData: state.pageContent.eventsData[ownProps.dataKey]
});

export default withRouter(
	connect(
		mapStateToProps,
		{ fetchEventsData }
	)(UpcomingEvents)
);



// WEBPACK FOOTER //
// ./src/components/organisms/UpcomingEvents/index.js